import React from 'react';

import WirelineEngagementsWidgets from 'pages/WirelineEngagements/WirelineEngagementsWidgets';
import CustomersCreateQuickForm from 'pages/Customers/CustomersCreate/CustomersCreateQuickForm';
import EngagementFormsWrapper from 'pages/WirelineEngagements/WirelineEngagementsCreate/EngagementFormsWrapper';
import AddOrderModalFormContextWrap from 'pages/WirelineEngagements/WirelineEngagementsCreate/AddOrderModalFormContextWrap';
import WirelineEngagementsCreateProvider from 'pages/WirelineEngagements/WirelineEngagementsCreate/WirelineEngagementsCreateContext';

const WirelineEngagementsCreate = () => (
  <WirelineEngagementsCreateProvider>
    <EngagementFormsWrapper />
    <WirelineEngagementsWidgets />
    <CustomersCreateQuickForm />
    <AddOrderModalFormContextWrap />
  </WirelineEngagementsCreateProvider>
);

export default WirelineEngagementsCreate;
